import { isAfter, isBefore, parseISO } from 'date-fns';

export const getCanNavPrevious = (previousMonth: Date | undefined, startMonth: string | undefined) => {
	return !!startMonth && !!previousMonth ? !isBefore(previousMonth, parseISO(startMonth)) : !!previousMonth;
};

export const getCanNavNext = (nextMonth: Date | undefined, endMonth: string | undefined) => {
	return !!endMonth && !!nextMonth ? !isAfter(nextMonth, parseISO(endMonth)) : !!nextMonth;
};
